import React from "react";
import OAGPromoLogo from "../OAGPromoLogo";
import OAGCopyright from "../OAGCopyright";
import SearchFlightsSFO from "../../features/searchFlights/SearchFlightsSFO";

function SFO() {
  return (
    <div className="container" id="search-results-column">
      <SearchFlightsSFO layout="horizontal" />
      <OAGCopyright />
      <OAGPromoLogo />
    </div>
  );
}

export default SFO;
